import { HIERARCHY_CHANGE, HIERARCHY_RESET } from 'cadenza/hierarchy-selection/event-types';
import { HIERARCHY_PARAM_PREFIX } from 'cadenza/api-client/processing-param-util';
import { on, unByKey } from 'cadenza/utils/event-util';
import {
  deleteUrlParamAndDoNotApply,
  getUrl,
  setUrlParamAndDoNotApply
} from 'cadenza/utils/url-param-utils';

export class AbstractSelectorResultController extends HTMLElement {

  connectedCallback () {
    this.initializeHierarchySelections();
  }

  disconnectedCallback () {
    this._resetHierarchySelectionEventKeys();
  }

  initializeHierarchySelections () {
    this._resetHierarchySelectionEventKeys();
    const hierarchySelections = document.querySelectorAll('d-hierarchy-selection');
    this._hierarchySelectionEventKeys = [];
    hierarchySelections.forEach(hierarchySelection => {
      this._hierarchySelectionEventKeys.push(on(hierarchySelection, HIERARCHY_CHANGE, event => this._onHierarchyChange(event.detail)));
      this._hierarchySelectionEventKeys.push(on(hierarchySelection, HIERARCHY_RESET, event => this._onHierarchyReset(event.detail)));
    });
    this.classList.add('hierarchyController');
  }

  _resetHierarchySelectionEventKeys () {
    this._hierarchySelectionEventKeys = this.resetEventKeys(this._hierarchySelectionEventKeys);
  }

  /**
   * Unregister the event keys
   *
   * @protected
   * @param eventKeyArray - the event keys
   * @return the empty event keys after reset
   */
  resetEventKeys (eventKeyArray) {
    if (eventKeyArray && eventKeyArray.length > 0) {
      unByKey(eventKeyArray);
    }
    return [];
  }

  _onHierarchyChange ({ name, selectedLevel }) {
    const urlSearchParams = setUrlParamAndDoNotApply({
      paramName: HIERARCHY_PARAM_PREFIX + name,
      paramValue: selectedLevel
    });
    this._updateUrl(urlSearchParams);
  }

  _onHierarchyReset ({ name }) {
    const urlSearchParams = deleteUrlParamAndDoNotApply({ name: HIERARCHY_PARAM_PREFIX + name });
    const url = getUrl(urlSearchParams);
    window.history.replaceState(null, null, url);
  }

  _updateUrl (urlSearchParams) {
    const url = getUrl(urlSearchParams);
    window.history.replaceState(null, null, url);
  }

  /**
   * Changes the url of the current window and refreshes the results if needed
   *
   * @protected
   * @param urlSearchParams - the parameters containing the url to change to
   * @return a promise indicating when the method has finished, in case overriding classes need to do async ops here
   */
  updateUrlAndRefreshResults (urlSearchParams) {
    const url = getUrl(urlSearchParams);
    window.location.replace(url);
    return Promise.resolve();
  }

  _isOnDemandExecution () {
    return this.getAttribute('on-demand-execution') === 'true';
  }

}
